export const BackToLoginLink = ({ onClick }: { onClick: () => void }) => (
  <div className="text-right mt-3">
    <button
      type="button"
      onClick={onClick}
      className="text-[0.8125rem] font-medium text-brand-pink bg-none border-none cursor-pointer p-0"
    >
      Back to login
    </button>
  </div>
);
